// extracted by css-extract-rspack-plugin
export default {"root":"RowIdHeaderCell-module__root___TAtGX"};